// ras 订阅的逻辑
import {combineLatest, BehaviorSubject} from 'rxjs';
import {filter, map, scan, startWith} from 'rxjs/operators';
import {rasMsgSubUsers$} from '@/raw/ras-all';
import {contractSubUserIds$} from '@/raw/users';
import {wsLogout$} from '@/user/auth-ws';

const rawAccountSubUsers$ = combineLatest([rasMsgSubUsers$, contractSubUserIds$]).pipe(
  filter(([{userId}, userIds]) => userIds.includes(userId)),
  map(([{userId, data}]) => {
    const wallets = data.risk_wallets || [];
    return function (cache) {
      if (wallets.length > 0) {
        const cur: Map<string, any> = cache.has(userId) ? cache.get(userId) : new Map();
        cache.set(
          userId,
          wallets.reduce(
            (p, c) =>
              p.set(c.currency, {
                totalBalanceRv: c.balanceRv || '0',
                totalBonusRv: c.totalBonusRv || '0',
                totalContractDebtRv: c.totalContractDebtRv || '0',
                totalInterestRv: c.totalInterestRv || '0',
                totalUsedBalanceRv: '0',
                isolatedTotalBalanceRv: '0',
              }),
            cur
          )
        );
      }
      return cache;
    };
  }),
  scan((p, action) => action(p), new Map()),
  startWith(new Map())
);

export const rasAccountSubUsers$ = new BehaviorSubject(new Map());

rawAccountSubUsers$.subscribe(rasAccountSubUsers$);
wsLogout$.subscribe(() => rasAccountSubUsers$.next(new Map()));
